// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-cache-admin {
  width: min(94vw, 640px);
  max-height: 84vh;
  background: #1c2c40;
  border: 1px solid #4a9eff;
  border-radius: 10px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.55);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.image-cache-admin__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.1rem 1.3rem;
  border-bottom: 1px solid rgba(74, 158, 255, 0.2);
}

.image-cache-admin__title {
  margin: 0;
  color: #fff;
  font-size: 1.2rem;
}

.image-cache-admin__close {
  background: none;
  border: none;
  color: #9fb4cc;
  font-size: 1rem;
  cursor: pointer;
  line-height: 1;
  padding: 0.3rem;
  border-radius: 6px;
  transition: background 0.2s, color 0.2s;
}

.image-cache-admin__close .icon { width: 1.1rem; height: 1.1rem; }

.image-cache-admin__close:hover {
  background: #23384f;
  color: #fff;
}

.image-cache-admin__body {
  padding: 1.1rem 1.3rem;
  overflow-y: auto;
  color: #cdd8e6;
  /* Match the app's shared dark-theme scrollbar (see styles.css). */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;
}

.image-cache-admin__body::-webkit-scrollbar {
  width: 8px;
}

.image-cache-admin__body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

.image-cache-admin__body::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.35);
}

.image-cache-admin__hint {
  margin: 0 0 0.9rem;
  font-size: 0.82rem;
  color: #9fb4cc;
  line-height: 1.5;
}

.image-cache-admin__form {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  padding: 0.9rem;
  margin-bottom: 1rem;
  background: rgba(74, 158, 255, 0.06);
  border: 1px solid rgba(74, 158, 255, 0.18);
  border-radius: 8px;
}

.image-cache-admin__field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  flex: 1 1 0;
  min-width: 0;
}

.image-cache-admin__field-row {
  display: flex;
  gap: 0.7rem;
}

.image-cache-admin__label {
  font-size: 0.75rem;
  color: #9fb4cc;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.image-cache-admin__input {
  width: 100%;
  box-sizing: border-box;
  padding: 0.5rem 0.6rem;
  background: #14202f;
  border: 1px solid #35506e;
  border-radius: 6px;
  color: #e6eef8;
  font-size: 0.88rem;
}

.image-cache-admin__input:focus {
  outline: none;
  border-color: #4a9eff;
}

.image-cache-admin__input:disabled {
  opacity: 0.6;
}

.image-cache-admin__form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.6rem;
}

.image-cache-admin__search {
  display: flex;
  gap: 0.6rem;
  margin-bottom: 0.9rem;
}

.image-cache-admin__search .image-cache-admin__input {
  flex: 1 1 auto;
}

.image-cache-admin__status {
  padding: 0.6rem 0;
  color: #9fb4cc;
  font-size: 0.9rem;
}

.image-cache-admin__error {
  padding: 0.6rem 0.8rem;
  margin-bottom: 0.8rem;
  background: rgba(255, 92, 92, 0.12);
  border: 1px solid rgba(255, 92, 92, 0.4);
  border-radius: 6px;
  color: #ff9b9b;
  font-size: 0.85rem;
}

.image-cache-admin__list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.image-cache-admin__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.65rem 0;
  border-bottom: 1px solid rgba(74, 158, 255, 0.12);
}

.image-cache-admin__row:last-child { border-bottom: none; }

.image-cache-admin__row-main {
  min-width: 0;
  flex: 1 1 auto;
}

.image-cache-admin__url {
  display: block;
  color: #8fc2ff;
  font-size: 0.85rem;
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.image-cache-admin__url:hover { text-decoration: underline; }

.image-cache-admin__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-top: 0.35rem;
}

.image-cache-admin__tag {
  padding: 0.1rem 0.5rem;
  border-radius: 10px;
  background: rgba(74, 158, 255, 0.18);
  color: #cfe4ff;
  font-size: 0.75rem;
}

.image-cache-admin__tag--line {
  background: rgba(160, 200, 120, 0.16);
  color: #cfe6b0;
}

.image-cache-admin__tag--empty {
  background: rgba(255, 255, 255, 0.08);
  color: #9fb4cc;
  font-style: italic;
}

.image-cache-admin__row-actions {
  display: flex;
  gap: 0.4rem;
  flex: 0 0 auto;
}

.image-cache-admin__action {
  padding: 0.35rem 0.6rem;
  background: #23384f;
  border: 1px solid #35506e;
  border-radius: 6px;
  color: #cdd8e6;
  font-size: 0.8rem;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.image-cache-admin__action:hover:not(:disabled) {
  background: #2c455f;
  color: #fff;
}

.image-cache-admin__action:disabled {
  opacity: 0.5;
  cursor: default;
}

.image-cache-admin__action--danger {
  border-color: rgba(255, 92, 92, 0.4);
  color: #ff9b9b;
}

.image-cache-admin__action--danger:hover:not(:disabled) {
  background: rgba(255, 92, 92, 0.15);
  color: #ffb3b3;
}

.image-cache-admin__footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 0.9rem 1.3rem;
  border-top: 1px solid rgba(74, 158, 255, 0.2);
}

.image-cache-admin__footer-left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
}

.image-cache-admin__reprocess-result {
  color: #9fb0c3;
  font-size: 0.85rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/image-cache-admin-panel/image-cache-admin-panel.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,kCAAkC,aAAa,EAAE,cAAc,EAAE;;AAEjE;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,kEAAkE;EAClE,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA,qCAAqC,mBAAmB,EAAE;;AAE1D;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,gCAAgC,0BAA0B,EAAE;;AAE5D;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[".image-cache-admin {\r\n  width: min(94vw, 640px);\r\n  max-height: 84vh;\r\n  background: #1c2c40;\r\n  border: 1px solid #4a9eff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.55);\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.image-cache-admin__header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  padding: 1.1rem 1.3rem;\r\n  border-bottom: 1px solid rgba(74, 158, 255, 0.2);\r\n}\r\n\r\n.image-cache-admin__title {\r\n  margin: 0;\r\n  color: #fff;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.image-cache-admin__close {\r\n  background: none;\r\n  border: none;\r\n  color: #9fb4cc;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  line-height: 1;\r\n  padding: 0.3rem;\r\n  border-radius: 6px;\r\n  transition: background 0.2s, color 0.2s;\r\n}\r\n\r\n.image-cache-admin__close .icon { width: 1.1rem; height: 1.1rem; }\r\n\r\n.image-cache-admin__close:hover {\r\n  background: #23384f;\r\n  color: #fff;\r\n}\r\n\r\n.image-cache-admin__body {\r\n  padding: 1.1rem 1.3rem;\r\n  overflow-y: auto;\r\n  color: #cdd8e6;\r\n  /* Match the app's shared dark-theme scrollbar (see styles.css). */\r\n  scrollbar-width: thin;\r\n  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;\r\n}\r\n\r\n.image-cache-admin__body::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.image-cache-admin__body::-webkit-scrollbar-thumb {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  border-radius: 4px;\r\n}\r\n\r\n.image-cache-admin__body::-webkit-scrollbar-thumb:hover {\r\n  background: rgba(255, 255, 255, 0.35);\r\n}\r\n\r\n.image-cache-admin__hint {\r\n  margin: 0 0 0.9rem;\r\n  font-size: 0.82rem;\r\n  color: #9fb4cc;\r\n  line-height: 1.5;\r\n}\r\n\r\n.image-cache-admin__form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.7rem;\r\n  padding: 0.9rem;\r\n  margin-bottom: 1rem;\r\n  background: rgba(74, 158, 255, 0.06);\r\n  border: 1px solid rgba(74, 158, 255, 0.18);\r\n  border-radius: 8px;\r\n}\r\n\r\n.image-cache-admin__field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.3rem;\r\n  flex: 1 1 0;\r\n  min-width: 0;\r\n}\r\n\r\n.image-cache-admin__field-row {\r\n  display: flex;\r\n  gap: 0.7rem;\r\n}\r\n\r\n.image-cache-admin__label {\r\n  font-size: 0.75rem;\r\n  color: #9fb4cc;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n}\r\n\r\n.image-cache-admin__input {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  padding: 0.5rem 0.6rem;\r\n  background: #14202f;\r\n  border: 1px solid #35506e;\r\n  border-radius: 6px;\r\n  color: #e6eef8;\r\n  font-size: 0.88rem;\r\n}\r\n\r\n.image-cache-admin__input:focus {\r\n  outline: none;\r\n  border-color: #4a9eff;\r\n}\r\n\r\n.image-cache-admin__input:disabled {\r\n  opacity: 0.6;\r\n}\r\n\r\n.image-cache-admin__form-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 0.6rem;\r\n}\r\n\r\n.image-cache-admin__search {\r\n  display: flex;\r\n  gap: 0.6rem;\r\n  margin-bottom: 0.9rem;\r\n}\r\n\r\n.image-cache-admin__search .image-cache-admin__input {\r\n  flex: 1 1 auto;\r\n}\r\n\r\n.image-cache-admin__status {\r\n  padding: 0.6rem 0;\r\n  color: #9fb4cc;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.image-cache-admin__error {\r\n  padding: 0.6rem 0.8rem;\r\n  margin-bottom: 0.8rem;\r\n  background: rgba(255, 92, 92, 0.12);\r\n  border: 1px solid rgba(255, 92, 92, 0.4);\r\n  border-radius: 6px;\r\n  color: #ff9b9b;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.image-cache-admin__list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.image-cache-admin__row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  padding: 0.65rem 0;\r\n  border-bottom: 1px solid rgba(74, 158, 255, 0.12);\r\n}\r\n\r\n.image-cache-admin__row:last-child { border-bottom: none; }\r\n\r\n.image-cache-admin__row-main {\r\n  min-width: 0;\r\n  flex: 1 1 auto;\r\n}\r\n\r\n.image-cache-admin__url {\r\n  display: block;\r\n  color: #8fc2ff;\r\n  font-size: 0.85rem;\r\n  text-decoration: none;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.image-cache-admin__url:hover { text-decoration: underline; }\r\n\r\n.image-cache-admin__meta {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.4rem;\r\n  margin-top: 0.35rem;\r\n}\r\n\r\n.image-cache-admin__tag {\r\n  padding: 0.1rem 0.5rem;\r\n  border-radius: 10px;\r\n  background: rgba(74, 158, 255, 0.18);\r\n  color: #cfe4ff;\r\n  font-size: 0.75rem;\r\n}\r\n\r\n.image-cache-admin__tag--line {\r\n  background: rgba(160, 200, 120, 0.16);\r\n  color: #cfe6b0;\r\n}\r\n\r\n.image-cache-admin__tag--empty {\r\n  background: rgba(255, 255, 255, 0.08);\r\n  color: #9fb4cc;\r\n  font-style: italic;\r\n}\r\n\r\n.image-cache-admin__row-actions {\r\n  display: flex;\r\n  gap: 0.4rem;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.image-cache-admin__action {\r\n  padding: 0.35rem 0.6rem;\r\n  background: #23384f;\r\n  border: 1px solid #35506e;\r\n  border-radius: 6px;\r\n  color: #cdd8e6;\r\n  font-size: 0.8rem;\r\n  cursor: pointer;\r\n  transition: background 0.2s, color 0.2s;\r\n}\r\n\r\n.image-cache-admin__action:hover:not(:disabled) {\r\n  background: #2c455f;\r\n  color: #fff;\r\n}\r\n\r\n.image-cache-admin__action:disabled {\r\n  opacity: 0.5;\r\n  cursor: default;\r\n}\r\n\r\n.image-cache-admin__action--danger {\r\n  border-color: rgba(255, 92, 92, 0.4);\r\n  color: #ff9b9b;\r\n}\r\n\r\n.image-cache-admin__action--danger:hover:not(:disabled) {\r\n  background: rgba(255, 92, 92, 0.15);\r\n  color: #ffb3b3;\r\n}\r\n\r\n.image-cache-admin__footer {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  padding: 0.9rem 1.3rem;\r\n  border-top: 1px solid rgba(74, 158, 255, 0.2);\r\n}\r\n\r\n.image-cache-admin__footer-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  min-width: 0;\r\n}\r\n\r\n.image-cache-admin__reprocess-result {\r\n  color: #9fb0c3;\r\n  font-size: 0.85rem;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
